import api from '../../api';

const reportService = {
    async getCurrentReport(guardian_id) {
        try {
            const response = await api.get(`reports/guardians/${guardian_id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching current report:', error);
            throw error;
        }
    },
  async getStudentReport(studentId) {
    try {
      const response = await api.get(`reports/students/${studentId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching student report:', error);
      throw error;
    }
  },

  async getStudentProgress(studentId) {
    try {
      const response = await api.get(`/guardian/student/${studentId}/progress`);
      return response.data;
    } catch (error) {
      console.error('Error fetching student progress:', error);
      throw error;
    }
  },

  async getMultiStudentReports(students, requested_by) {
    try {
      const response = await api.post('/reports/multi-student', {students, requested_by});
      return response.data;
    } catch (error) {
      console.error('Error fetching multi-student reports:', error);
      throw error;
    }
  },

  async getStudentQuizHistory(studentId) {
    try {
      const response = await api.get(`/guardian/student/${studentId}/quiz-history`);
      return response.data;
    } catch (error) {
      console.error('Error fetching student quiz history:', error);
      throw error;
    }
  }
};

export { reportService };
